import { useCallback } from "react";

interface ITimeInputProps {
    label: string;
    value: number;
    min: number;
    max: number;
    onChange: (value: number) => void;
    disableUp?: boolean;
    disableDown?: boolean;
}


export function TimeInput(props: ITimeInputProps) {
    
    const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = Number(e.target.value);
        if (!isNaN(newValue)) {
            props.onChange(newValue);
        }
    }, [props]);

    return (
        <div className="time-input">
            <input
                type="number"
                value={props.value.toString().padStart(2, "0")}
                onChange={handleInputChange}
            />
            <div className="custom-buttons">
                <div
                    className={`custom-button up ${props.disableUp ? "disable" : ""}`}
                    onClick={() => !props.disableUp && props.onChange(props.value + 1)}
                >
                    +
                </div>
                <div
                    className={`custom-button down ${props.disableDown ? "disable" : ""}`}
                    onClick={() => !props.disableDown && props.onChange(props.value - 1)}
                >
                    -
                </div>
            </div>
        </div>
    );
}